import { useState } from "react";
import { Header } from "@/components/Header";
import { LeadModal } from "@/components/LeadModal";
import { Seo } from "@/components/Seo";
import { Hero } from "@/sections/Hero";
import { StatsSection, WhySection, TestimonialsSection, ProgramsSection, ClassroomSection, VisitSection } from "@/sections/MidSections";
import { InstagramSection } from "@/sections/InstagramSection";
import { FinalCta, StickyMobileBar, WhatsAppFloat } from "@/sections/Closing";

const SEO_TITLE = "Free Career Session: AI, Cybersecurity & Data Courses, Delhi";
const SEO_DESC = "Not sure which tech course fits you? Book a free 20-minute career session — AI, cybersecurity, data science, data analytics and cloud. No experience needed.";

export default function LandingPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <Seo title={SEO_TITLE} description={SEO_DESC} />
      <Header onCta={openModal} />
      <Hero onCta={openModal} />
      <StatsSection />
      <WhySection />
      <TestimonialsSection onCta={openModal} />
      <InstagramSection />
      <ProgramsSection />
      <ClassroomSection onCta={openModal} />
      <VisitSection />
      <FinalCta onCta={openModal} />
      <footer className="py-10 pb-28 sm:pb-10 text-center" style={{ background: "var(--bg-primary)" }} data-testid="page-footer">
        <img src="/images/logo.png" alt="Institute logo" className="mx-auto w-14 h-14 rounded-xl object-cover mb-4" style={{ border: "1px solid var(--input-border)" }} data-testid="footer-logo" />
        <p className="text-xs" style={{ color: "var(--text-muted)" }}>
          Tech Career Institute · Delhi · Your details are 100% confidential
        </p>
      </footer>
      <LeadModal open={modalOpen} onClose={closeModal} />
      <StickyMobileBar onCta={openModal} hidden={modalOpen} />
      <WhatsAppFloat hidden={modalOpen} />
    </>
  );
}
